import axiosCall from './interceptor';
import URL from '../helper';

export const getVersionTags = async (channel, designType, documentId) => {
    const url = `${URL.DESIGN_SYSTEM_URL}tag/${channel}/${designType}/${documentId}`;
    const response = await axiosCall('get', url);
    return response.data;
}

export const createVersionTag = async data => {
  let url = `${URL.DESIGN_SYSTEM_URL}tag`;
  if (data.env === 'live' || data.env === 'sandbox') {
    url = `${URL.TRANSACTION_SYSTEM_URL}tag`;
  }
  const response = await axiosCall('post', url, data);
  return response.data;
};

export const deleteVersionTag = async (tagId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}tag/${tagId}`;
  const response = await axiosCall('delete', url);
  return response.data;
}

export const getTagDocument = async (tagId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}tag/fetchDesign/${tagId}`;;
  const response = await axiosCall('get', url);
  return response.data;
};

export const applyTag = async (channel, tagId) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}tag/applyTag/${channel}/${tagId}`;
  const response = await axiosCall('post', url);
  return response.data;
}

export const getAuditDetails = async (draftId, type, sortOrder) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}version/audit?id=${draftId}&type=${type}&sort=${sortOrder}`;
  const response = await axiosCall('get', url);
  return response.data;
}
